<script>
import {defineComponent} from 'vue'
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import moment from "moment";

export default defineComponent({
  name: "StateTargetFunds",
  computed: {
    moment() {
      return moment
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      selectedYear: null,
      quarter: null,
      fund_id: null,
      page: 1,
      totalCount: 0,
      limit: 10,

      funds: [],
      quarters: [
        {value: 1},
        {value: 2},
        {value: 3},
        {value: 4}
      ],
    }
  },
  watch: {
    selectedYear() {
      this.getStateFundList()
    },
    quarter() {
      this.getStateFundList()
    },
    fund_id() {
      this.getStateFundList()
    }
  },
  methods: {
    indexMethod(index) {
      return index + (this.page - 1) * this.limit + 1
    },
    handleCurrentChange() {
      this.getStateFundList();
    },
    handleSizeChange() {
      this.page = 1;
      this.getStateFundList();
    },
    getFundList() {
      this.loading = true;
      this.$http.get(`api/v1/funds`, {
        params: {
          limit: 10000,
          offset: 0
        }
      }).then(({data}) => {
        this.funds = data.data;
      }).catch(({response}) => {
        ElNotification.error({message: response.data.message || "Ma'lumot yuklashda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring."})
      }).finally(() => {
        this.loading = false
      })
    },
    onClickDelete(id) {
      ElMessageBox.confirm(
          'Ma\'lumoitni o\'chirasizmi?',
          'Diqqat!',
          {
            confirmButtonText: 'Ha',
            cancelButtonText: 'Bekor qilish',
            type: 'warning',
          }
      )
          .then(() => {
            this.loading = true
            this.$http.delete(`/api/v1/state-target-funds/${id}`).then(() => {
              ElMessage({
                type: 'success',
                message: 'Muvaffaqqiyatli o\'chirildi',
              })
              this.getStateFundList();
            }).catch(() => {
              ElNotification({
                type: 'error',
                title: 'Xatolik',
                message: 'Iltimos, qayta urinib ko\'ring',
              })
            }).finally(() => {
              this.loading = false
            })

          })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: 'O\'chirish bekor qilindi',
            })
          })
    },
    getStateFundList() {
      this.loading = true;
      this.$http.get(`api/v1/state-target-funds`, {
        params: {
          limit: this.limit,
          offset: this.limit * (this.page - 1),
          year: this.selectedYear,
          quarter: this.quarter,
          fund_id: this.fund_id
        }
      }).then(({data}) => {
        this.tableData = data.data;
        this.totalCount = data.count;
      }).catch(({response}) => {
        ElNotification.error({message: response.data.message || "Ma'lumot yuklashda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring."})
      }).finally(() => {
        this.loading = false
      })
    },
  },
  mounted() {
    this.getStateFundList();
    this.getFundList()
  }
})
</script>

<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <div class="filters">
        <el-date-picker
            size="large"
            style="width: 100%"
            v-model="selectedYear"
            type="year"
            format="YYYY"
            value-format="YYYY"
            clearable
            placeholder="Yilni tanlang"
        />
        <el-select class="form-input" v-model="quarter" size="large"
                   style="width: 100%"
                   clearable
                   placeholder="Chorakni tanlang">
          <el-option v-for="item in quarters"
                     :value="item.value"
                     :label="item.value"
                     :key="item.value"/>
        </el-select>
        <el-select class="form-input" v-model="fund_id" size="large"
                   style="width: 100%"
                   clearable
                   placeholder="Jamg'armani tanlang">
          <el-option v-for="item in funds"
                     :value="item.id"
                     :label="item.title"
                     :key="item.id"/>
        </el-select>
      </div>
      <el-button type="primary" @click="$router.push({name: 'StateFundFormAdd'})">Qo'shish</el-button>
    </div>
    <el-table :data="tableData" class="table" border height="calc(100vh - 245px)">
      <el-table-column type="index" label="T/R" width="80" :index="indexMethod" align="center"/>
      <el-table-column prop="fund" label="Jamg'arma nomi" min-width="220"/>
      <el-table-column prop="year" label="Yili" min-width="60"/>
      <el-table-column prop="revenue" label="Daromad" min-width="120"/>
      <el-table-column prop="transfers" label="Transfer" min-width="120"/>
      <el-table-column prop="expenditure" label="Xarajat" min-width="120"/>
      <el-table-column prop="created_at" label="Yaratilgan sana" min-width="140">
        <template v-slot="scope">
          {{ moment(scope.row.created_at).format("DD.MM.YYYY") }}
        </template>
      </el-table-column>
      <el-table-column label="" width="200" align="center">
        <template #default="scope">
          <el-button type="primary" size="small"
                     @click="$router.push({name: 'StateFundFormEdit', params:{id: scope.row.id}})">Tahrirlash
          </el-button>
          <el-button type="danger" size="small"
                     @click="onClickDelete(scope.row.id)">O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <div>Umumiy soni: {{ totalCount }}</div>
      <el-pagination
          background
          layout="sizes, prev, pager, next"
          :total="totalCount"
          v-model:page-size="limit"
          v-model:current-page="page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<style scoped>
.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  gap: 10px;
  align-items: center;

  .filters {
    display: flex;
    gap: 10px
  }
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
